<template>
<div class="">
<div class="util-edit-wrap" v-if="status === 'editing'" style="opacity: .8">
  <a class="util-btn is-edit" @click="dashboard.editing = !dashboard.editing">编辑</a>
  <a class="util-btn is-download" @click="gethtml">下载页面</a>
  <a class="util-btn is-download" @click="getJson">下载数据</a>
  <a class="util-btn is-edit" href="https://admin.geekbang.org/sms/#/image/list" target="_blank">打开图床</a>
    <div class="util-dashboard" v-show="dashboard.editing" @mousedown="mousedown" @mouseup="mouseup" :style="{'left': dashboard.left, 'top':dashboard.top}">
      <div class="util-dashboard-wrap"><editor :data="data" :keys="status"></editor></div>
    </div>
</div>
</div>
</template>

<script>
import download from './vender/download'
import temp from './temp'
import editor from './editor'
import { EventBus } from './event-bus'

export default {
  props: ['data', 'debug'],
  components: {
    editor
  },
  data () {
    return {
      status: 'prod', // prod, editing
      dashboard: {
        editing: false,
        dragstartx: 0,
        dragstarty: 0,
        left: '20px',
        top: '20px',
        draging: false
      }
    }
  },
  methods: {
    deepLoop (data, key, type) {
      for (var k in data) {
        if (key === k) {
          let newInfo = JSON.parse(JSON.stringify(data[key][0]))
          // Object.keys(newInfo).forEach(k => {
          //   newInfo[k] = ''
          // })
          if (typeof newInfo === 'string') {
            newInfo = '';
          } else {
            Object.keys(newInfo).forEach(k => {
              if (k === '是否显示') {
                newInfo[k] = true;
              }else {
                newInfo[k] = '';
              }
            })
          }
          if(type === 'push') {
            data[key].push(newInfo);
          }else if(type === 'unshift') {
            data[key].unshift(newInfo);
          }
          
        } else {
          if(typeof data[k] === 'object') {
            this.deepLoop(data[k], key, type)
          }
        }
      }
    },
    // editing
    gethtml () {
      if (!document.querySelectorAll('.in-head').length) return
      let inHeadsArr = document.querySelectorAll('.in-head')
      let inHeads = ''
      inHeadsArr.forEach(ele => {
        inHeads += ele.outerHTML
      })
      let inBodyArr = document.querySelectorAll('.in-body')
      let inBodys = ''
      inBodyArr.forEach(ele => {
        inBodys += ele.outerHTML
      })
      let data = JSON.stringify(this.data)
      download(temp.generateHtml(this.data.head, data, inHeads, inBodys), 'index.html', 'text/html')
    },
    getJson () {
      let data = JSON.stringify(this.data, null, '  ')
      download(data, 'data.json', 'text/json')
    },
    mousedown (e) {
      if (e.target === e.currentTarget) {
        this.dashboard.draging = true
        var moveElemRect = e.currentTarget.getBoundingClientRect()
        this.dashboard.dragstartx = e.clientX - moveElemRect.left // 鼠标按下时和选中元素的坐标偏移:x坐标
        this.dashboard.dragstarty = e.clientY - moveElemRect.top // 鼠标按下时和选中元素的坐标偏移:y坐标
      }
    },
    mouseup () {
      this.dashboard.draging = false
    }
  },
  created () {
    if (window.location.protocol.indexOf('file') > -1 ||
        window.location.search.indexOf('status=editing') > -1) {
      this.status = 'editing'
    }
    if (this.debug) this.status = 'editing'
    window.onmousemove = (e) => {
      if (this.dashboard.draging) {
        this.dashboard.left = e.clientX - this.dashboard.dragstartx + 'px'
        this.dashboard.top = e.clientY - this.dashboard.dragstarty + 'px'
      }
    }
  },
  mounted() {
    EventBus.$on('addLine', (key, type) => {
      this.deepLoop(this.data, key, type)
    })
  }
}
</script>

<style lang="sass">
=mobile
  @media screen and (max-width: 768px)
    @content

=tablet
  @media screen and (min-width: 769px)
    @content

.util-edit-wrap
  position: fixed
  bottom: 20px
  left: 20px
  display: flex
  z-index: 1000
.util-btn
  margin-right: 20px
  display: flex
  color: #fff
  font-size: 16px
  border-radius: 5px
  padding: 10px 20px
  cursor: pointer
  z-index: 1000
  transition: opacity 0.3s
  user-select: none
  &:hover
    opacity: 0.8
.util-btn.is-edit
  background-color: blue
.util-btn.is-download
  background-color: green
.util-dashboard
  cursor: move
  display: block
  position: fixed
  padding: 40px 0 0 0
  width: 70%
  height: 70%
  background: #f3ca9d
  box-shadow: 0 0 20px 0 #888
  border-radius: 10px
  overflow: hidden
  &:before
    content: '拖动窗口'
    position: absolute
    top: 8px
    left: 20px
.util-dashboard-wrap
  cursor: default
  padding: 0 20px
  background: #fff
  width: 100%
  height: 100%
  overflow: scroll

</style>
